<div class="modal-dialog modal-full modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" i18n>Id da infração: {{ violation?.passId }}</h5>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="modal-body">
      <div class="image-gallery"
        *ngIf="files && files.length > 0; else noImages">
        <div class="image-gallery__main">
          <div *ngFor="let file of files; let i = index"
            [ngClass]="{'d-block': stateImage === i, 'd-none': stateImage !== i}">
            <figure *ngIf="file.type !== 'video' && file.type !== 'video2'">
              <img src="{{ file.urlCurrent || file.urlDecrypted }}"
                alt="{{ file.type }}" />
            </figure>

            <video *ngIf="file.type === 'video' || file.type === 'video2'"
              controls autoplay loop muted>
              <source src="{{ file.urlCurrent || file.urlDecrypted }}"
                type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        <div class="image-gallery__thumbs">
          <div *ngFor="let file of files; let i = index"
            (click)="stateImage = i" [ngClass]="{'active': stateImage === i}">
            <figure *ngIf="file.type !== 'video' && file.type !== 'video2'">
              <img src="{{ file.urlCurrent || file.urlDecrypted }}"
                alt="{{ file.type }}" />
            </figure>

            <video *ngIf="file.type === 'video' || file.type === 'video2'"
              controls autoplay loop muted>
              <source src="{{ file.urlCurrent || file.urlDecrypted }}"
                type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>

      <ng-template #noImages>
        <div class="card mb-3" *ngIf="!loading">
          <div class="card-body text-center">
            <p i18n>Não há imagens.</p>
          </div>
        </div>
      </ng-template>

      <div class="loading-page" *ngIf="loading">
        <div class="loading-spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="more-info">
            <div class="d-flex">
              <div *ngIf="regulations.length > 0; else onlyRegulation">
                <p i18n-appTooltip
                  [appTooltip]="getRegulationInfo(violation.regulationId)">
                  <span i18n>Enquadramento:</span> <i>{{
                    getRegulationCode(violation.regulationId) }}</i>
                </p>
              </div>
              <ng-template #onlyRegulation>
                <p>
                  <span i18n>Enquadramento:</span> <i>{{
                    getRegulationCode(violation.regulationId) }}</i>
                </p>
              </ng-template>
              <div class="mr-3">
                <p class="mb-0 text-center"><span i18n>Velocidade</span></p>
                <div class="d-flex justify-content-between">
                  <p><span i18n>Permitida:</span> {{ violation.speedLimit ?
                    violation.speedLimit + 'km/h' : '--'}}</p>
                  <p [ngClass]="{'speedWarning': violation?.speedWarning}"><span
                      i18n>Registrada:</span> {{ violation.speed ?
                    violation.speed + 'km/h' : '--' }}</p>
                  <p><span i18n>Considerada:</span> {{ violation.calculatedSpeed
                    ? violation.calculatedSpeed + 'km/h' : '--' }}</p>
                </div>
              </div>
              <p>
                <span i18n>Data/Hora de cometimento:</span>
                {{ getDateTime(violation.date) }}
              </p>
            </div>

            <div class="d-flex">
              <p><span i18n>Faixa:</span> {{ lane?.prettyNames[0] || '--' }}</p>
              <p><span i18n>Série do equipamento:</span> {{
                violation?.equipment?.serialNumber || '--' }}</p>
              <p><span *ngIf="violation?.equipment?.calibration?.date" i18n>Data
                  de aferição:</span> {{ violation?.equipment?.calibration?.date
                | moment: 'DD/MM/YYYY' }}</p>
              <p><span *ngIf="!violation?.equipment?.calibration?.date"
                  i18n>Data de aferição:</span> {{ '--' }}</p>
            </div>
            <div class="d-flex">
              <p><span i18n>Local:</span> {{ violation?.address?.street }}</p>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="more-info" *ngIf="!loading">
            <div class="d-flex w-100">
              <p><span i18n>Placa:</span> <i>{{ violation?.vehicle?.plate ||
                  '--' }}</i></p>
              <p><span i18n>Cor:</span> {{ color?.description || '--' }}</p>
              <p><span i18n>Ano:</span> {{ violation?.vehicle?.year || '--'
                }}</p>
              <p><span i18n>Marca/Modelo:</span> {{ brandModel?.description ||
                '--' }}</p>
            </div>

            <div class="d-flex w-100">
              <p><span i18n>Categoria:</span> {{ category?.description || '--'
                }}</p>
              <p><span i18n>Classificação:</span> {{ classification?.description
                || '--' }}</p>
            </div>

            <div class="d-flex w-100">
              <p><span i18n>País:</span> {{ region?.name || '--' }}</p>
              <p><span i18n>UF:</span> {{ (violation.vehicle?.abbreviation ||
                state?.abbreviation) || '--' }}</p>
              <p><span i18n>Município:</span> {{ city?.name || '--' }}</p>
            </div>
          </div>
          <div class="loading-page" *ngIf="loading">
            <div class="loading-spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
